// API contract: totalUrlCount = -1 means internet search has not been executed yet.
export const checkResult = {
  NOT_EXECUTED_TOTAL_URL_COUNT: -1,
} as const;
